var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditcardfill({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 3.16667C24 2.32681 23.7082 1.52136 23.1889 0.927495C22.6696 0.33363 21.9652 0 21.2308 0H2.76923C2.03479 0 1.33042 0.33363 0.811089 0.927495C0.291757 1.52136 0 2.32681 0 3.16667V4.22222H24V3.16667ZM0 15.8333C0 16.6732 0.291757 17.4786 0.811089 18.0725C1.33042 18.6664 2.03479 19 2.76923 19H21.2308C21.9652 19 22.6696 18.6664 23.1889 18.0725C23.7082 17.4786 24 16.6732 24 15.8333V6.33333H0V15.8333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardfill);
export default __webpack_public_path__ + "static/media/creditcard.fill.099c7ee3562c5f49a0884deb536fb0c9.svg";
export { ForwardRef as ReactComponent };